import request from '@/utils/request';

// 获取考勤设置信息
export const getClockInSet = (params: any) =>
  request({
    url: 'PunchTheClock/clockSet',
    method: 'get',
    params
  });

// 所有的考勤人员列表
export const getAllClockUserList = (params: any) =>
  request({
    url: 'User/userList',
    method: 'get',
    params
  });

// 已选择的考勤人员列表
export const getClockUserList = (params: any) =>
  request({
    url: 'PunchTheClock/clockUser',
    method: 'get',
    params
  });

// 设置考勤人员
export const setClockUser = (data: any) =>
  request({
    url: 'PunchTheClock/clockUser',
    method: 'PUT',
    data
  });

// 启用、关闭考勤人员
export const switchClockUser = (data: any) =>
  request({
    url: 'PunchTheClock/swicthUser',
    method: 'PUT',
    data
  });

// 设置考勤班次
export const setClockInInfo = (data: any) =>
  request({
    url: 'PunchTheClock/clockClass',
    method: 'PUT',
    data
  });

// 设置考勤地址
export const setClockInAddress = (data: any) =>
  request({
    url: 'PunchTheClock/clockAddress',
    method: 'PUT',
    data
  });
